export default {
  downtimeUrl: "https://id2.kodland.tech",
  startPage: {
    image: "/welcome/quiz_project_girl.jpeg",
    title: "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    subtitle:
      "Anak-anak akan mencoba kreativitas digital mereka: kartun, animasi, ilustrasi, pemodelan, 3D, desain",
    button: "Mulai🚀",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Apakah anda ingin waktu yang dihabiskan anak anda di depan komputer menjadi lebih produktif?",
      answers: ["😍 Ya!", "🙂 Tidak. Ini hanya untuk bersenang-senang dan tidak masalah."],
    },
    2: {
      title: "Nama lengkap anak Anda",
      type: "child_name",
      subtitle: "Data dilindungi dan akan dihapus atas permintaan Anda🚨",
      button: "Pergi ke langkah berikutnya 🚀",
    },
    3: {
      title: "Berapa usia anak Anda?",
      type: "age",
      subtitle: "Kami akan memilihkan kursus yang paling menghibur sesuai dengan usia anak",
      button: "Pergi ke langkah berikutnya 🚀",
    },
    4: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
        "🏛️ Ilmu budaya",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    5: {
      title: "Jam berapa Anda bisa mengambil pelajaran percobaan?",
      type: "timeslot",
      subtitle:
        "Beberapa langkah lagi kita akan sampai pada pemesanan pelajaran individu untuk anak Anda! Tidak sabar untuk bertemu dengan Anda🥳",
      button: "wooooow 🚀",
    },
    6: {
      title: "Siapa nama Anda?",
      type: "parent_name",
      subtitle: "Nama kami adalah Kodland, siapa nama Anda?👋",
      button: "Pergi ke langkah berikutnya 🚀",
    },
    7: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    8: {
      title: "Silakan, masukkan email Anda",
      type: "mail",
      subtitle: "Jangan khawatir, tidak ada spam yang akan dikirim😅",
      button: "Pergi ke langkah berikutnya 🚀",
    },
    9: {
      title: "Silakan, masukkan nomor telepon",
      type: "phone",
      subtitle: "Tidak ada panggilan📞 sampai jumpa di messenger!",
      button: "hampir selesai 🚀",
    },
  },
};
